export default __webpack_public_path__ + "static/media/michelle.e06ba8b5.bin";